/**
 * ViewWidthScaling React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';


function getScaleFactor(width) {
    const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width / viewWidth;
}


/**
 * scaling component designed for 100vw width
 *
 * @author Jens Gruschel
 */
class ViewWidthScaling extends React.Component {

    constructor(props) {
        super(props);
        this.state = {scaleFactor: getScaleFactor(props.width)};
    }

    updateDimensions() {
        this.setState({scaleFactor: getScaleFactor(this.props.width)});
    }

    componentDidMount() {
        // this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {

        return <div style={{width: this.props.width, height: this.props.height, overflow: "hidden", margin: "0 auto"}}>
            <div style={{transform: "scale(" + this.state.scaleFactor + ")", transformOrigin: "0 0"}}>
                {this.props.children}
            </div>
        </div>;
    }
}

ViewWidthScaling.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default ViewWidthScaling;